export const getPUErrorMessage = errorType => {
  let titleMessage = 'app.detailsPanel.notFoundDescription';
  let descriptionMessage = 'app.detailsPanel.notFoundHint';
  let showUpgradeLink = false;
  if (errorType) {
    if (errorType === 'NO_VALID_SUBSCRIPTION') {
      titleMessage = 'app.detailsPanel.accessError';
      descriptionMessage = 'app.detailsPanel.subscriptionHint_jsx';
      showUpgradeLink = true;
    } else if (errorType === 'NO_GATE_ACCESS' || errorType === 'NO_SCOPE_ACCESS') {
      titleMessage = 'app.detailsPanel.accessError';
      descriptionMessage = 'app.detailsPanel.accessHint';
    } else if (errorType === 'NO_ROLLOUT_FOUND') {
      titleMessage = 'app.detailsPanel.noRolloutError';
      descriptionMessage = 'app.detailsPanel.noRolloutHint';
    } else if (errorType === 'NOT_PUBLISHED') {
      titleMessage = 'app.detailsPanel.notPublishedError';
      descriptionMessage = 'app.detailsPanel.notPublishedHint';
    }
  }
  return {
    titleMessage,
    descriptionMessage,
    showUpgradeLink
  };
};